import {ActionService} from "../../../../../opportunity_actions_service/service/ActionService";
import {OpportunityAction} from "../../../../model/OpportunityAction";
import {ToastNotificationService} from "../../../../../utils/ToastNotificationService";
import * as angular from "angular";
import {IHttpPromise, IPromise} from "angular";
import {AddressPromptDialog, LetterAddress} from "../../../../../opportunities/address/address-prompt.component";
import {Opportunity} from "../../../../../opportunities/model/Opportunity";
import {ActionComponent, ActionComponentScope} from "../../action.component";
import {AddressServiceName} from "../../../../../utils/names/serviceNames";
import {AddressService} from "../../../../../address/service/address.service";
import {ActionStatus} from "../../../../../action_status/model/ActionStatus";
import {ActionTypes} from "../../../../../action_status/model/ActionType";
import {UserGranredAuthorityName} from "modules/router/const/AllPermitions";

interface SendLetterActionScope extends ActionComponentScope {
}

export class SendLetterAction extends ActionComponent {

    static instance = () => ActionComponent.instance(SendLetterAction, [AddressServiceName]);

    constructor($scope: SendLetterActionScope,
                actionService: ActionService,
                $exceptionHandler: ng.IExceptionHandlerService,
                $mdDialog: angular.material.IDialogService,
                toastService: ToastNotificationService,
                private addressService: AddressService) {
        super($scope, actionService, $exceptionHandler, $mdDialog, toastService);
    }

    protected $scope: SendLetterActionScope;
    private letterAddress: LetterAddress;

    sendMail = (): IHttpPromise<OpportunityAction[]> => {
        let opportunity = this.$scope.opportunity;
        let customerName = opportunity.customer.firstName + ' ' + opportunity.customer.lastName;
        return this.fetchAddress()
            .then(() => {
                return this.showAddressDialog(customerName);
            }).then((letterAddress: LetterAddress) => {
                return this.postAddress(letterAddress)
            }).then(() => {
                return this.sendActionRequest(opportunity);
            });
    };


    private sendActionRequest(opportunity: Opportunity) {
        return this.actionService.sendActionRequest(
            opportunity.id, this.getOpportunityAction(opportunity));
    }

    private postAddress(letterAddress: LetterAddress) {
        return this.addressService.postAddress(this.opportunity.customer.id, letterAddress.to)
            .then(resp => {
                this.letterAddress = letterAddress;
                this.letterAddress.to = resp.data;
                return letterAddress;
            }, (letterAddress) => {
                this.letterAddress = letterAddress;
            });
    }

    private showAddressDialog(customerName: string) {
        let dialog = AddressPromptDialog.instance(this.letterAddress, customerName);
        return this.$mdDialog.show(dialog);
    }

    private fetchAddress() {
        return this.addressService.fetchLetterAddress(
            this.opportunity.customer.id,
            this.opportunity.customer.employee.id
        ).then(letterAddress => {
            this.letterAddress = letterAddress;
            this.auditLetterAddress(letterAddress);
        })
    }

    private getOpportunityAction(opportunity: Opportunity): OpportunityAction {
        return {
            actionType: this.getActionType(),
            customerId: opportunity.customer.id,
            calculatorId: opportunity.calculator.id,
            calculationExecutionLogId: opportunity.id,
            status: ActionStatus.NEW,
        };
    }

    protected isDisabled(opportunity: Opportunity): boolean {
        //everything except Epo thing
        return super.isDisabled(opportunity) ||
            !this.hasAccessToPhysicalLetter();
    }

    private hasAccessToPhysicalLetter(): boolean {
        return  this.principle.userAccessLevels.find(f => f.authorityName == UserGranredAuthorityName.OPPORTUNITY_PHYSICAL_MAILING).status
    }


    protected executeAction: () =>
        IPromise<angular.IHttpResponse<OpportunityAction[]>> = () => this.sendMail();

    protected getActionType = () => ActionTypes.DIRECT_MAILER;

    protected getTitle = () => "Send Physical Letter";

    protected getIcon = () => "/app/images/icons/postcard.svg";

    protected getErrorMessage = () => {
        console.log(this.letterAddress);
        let message = "Failed to perform action\n";
        if (this.letterAddress == null) {
            message += "No address provided";
            return message;
        } else {

            if (!this.letterAddress.from.verification.valid) {
                message = message + "Your branch address is invalid: " + this.letterAddress.from.verification.message + "\n";
            }

            return message;
        }
    };


    protected getSuccessMessage = () => {
        console.log(this.letterAddress);
        return "Letter will be delivered";
    };

    private auditLetterAddress(letterAddress: LetterAddress) {
        if (letterAddress.from == null
            || letterAddress.from.verification == null
            || !letterAddress.from.verification.valid) {
            throw 'Letter address is invalid ' + letterAddress;
        }
    }
}